export default "__VITE_ASSET__693aebd5__"